import React from 'react';
import PropTypes from 'prop-types';

const DesktopProductsHeader = ({ children }) => (
  <div className="items-center bg-white flex h-[53px] p-0 sticky top-[55px] z-[11] max-[1023px]:hidden">
    {children}
  </div>
);

DesktopProductsHeader.propTypes = {
  children: PropTypes.node,
};

export default DesktopProductsHeader;
